import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  "data-wizard-header": "",
  class: "-mx-4 -my-1.5 flex min-w-0 flex-1 items-center justify-between gap-4 bg-white px-6 py-3.5 md:px-7"
}
const _hoisted_2 = { class: "flex min-w-0 flex-col gap-0.5" }
const _hoisted_3 = {
  "aria-label": "Breadcrumb",
  class: "text-[13px] text-gray-500"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "flex min-w-0 items-center gap-2.5" }
const _hoisted_6 = {
  "data-top": "",
  class: "m-0 truncate pb-0.5 text-[22px] font-bold leading-snug tracking-[-0.02em] text-gray-900"
}
const _hoisted_7 = {
  key: 0,
  "data-draft-pill": "",
  class: "flex-shrink-0 rounded-full bg-[#fef3c7] px-[9px] py-[3px] text-xs font-semibold text-[#92400e]"
}
const _hoisted_8 = { class: "flex flex-shrink-0 items-center gap-2" }
const _hoisted_9 = { class: "flex h-full bg-[#f6f7f9]" }
const _hoisted_10 = { class: "flex min-h-0 min-w-0 flex-1 flex-col" }
const _hoisted_11 = { class: "flex-1 overflow-y-auto px-6 py-9 md:px-10" }
const _hoisted_12 = { class: "mx-auto max-w-[920px]" }
const _hoisted_13 = {
  key: 0,
  "data-load-error": "",
  class: "flex items-center justify-between gap-4 rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700"
}
const _hoisted_14 = { class: "m-0" }
const _hoisted_15 = {
  key: 1,
  "data-loading": "",
  class: "text-sm text-gray-500"
}
const _hoisted_16 = { class: "flex flex-col gap-1.5 pb-7" }
const _hoisted_17 = {
  "data-eyebrow": "",
  class: "m-0 text-[13px] font-semibold text-gray-500"
}
const _hoisted_18 = {
  "data-step-question": "",
  class: "m-0 text-2xl font-bold tracking-[-0.02em] text-gray-900"
}
const _hoisted_19 = {
  key: 0,
  class: "m-0 mt-1 max-w-2xl text-sm leading-relaxed text-gray-600"
}
const _hoisted_20 = {
  key: 0,
  "data-errors": "",
  class: "mb-6 rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700"
}
const _hoisted_21 = { "data-step": "" }
const _hoisted_22 = {
  key: 0,
  "data-wizard-footer": "",
  class: "border-t border-gray-200 bg-white px-6 py-3.5 md:px-12"
}
const _hoisted_23 = {
  key: 0,
  class: "flex items-center gap-4"
}
const _hoisted_24 = {
  key: 1,
  "data-no-permission": "",
  class: "text-sm text-amber-700"
}
const _hoisted_25 = {
  key: 2,
  "data-save-blocker": "",
  class: "text-sm text-amber-700"
}
const _hoisted_26 = { class: "flex-1" }
const _hoisted_27 = {
  key: 1,
  class: "flex items-center gap-4"
}
const _hoisted_28 = {
  key: 0,
  "data-no-permission": "",
  class: "text-sm text-amber-700"
}
const _hoisted_29 = { class: "flex-1" }

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { onBeforeRouteLeave, onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import WizardButton from '@/components/neue/wizard/WizardButton.vue'
import WizardConfirmModal from '@/components/neue/wizard/WizardConfirmModal.vue'
import WizardNav from '@/components/neue/wizard/WizardNav.vue'
import WizardRail from '@/components/neue/wizard/WizardRail.vue'
import SecondaryNav from '@/components/SecondaryNav.vue'
import { useConfirm } from '@/composables/useConfirm'
import { provideHighlightTerms } from '@/composables/useHighlightTerms'
import { useMembershipTierWizard } from '@/composables/useMembershipTierWizard'
import { useToast } from '@/composables/useToast'
import { useUnloadGuard } from '@/composables/useUnloadGuard'
import { provideWizard } from '@/composables/useWizardContext'
import { tierDraft } from '@/composables/useWizardDraft'
import {
  includeOptions,
  removalWarnings,
  stepHeading,
  stepSubtitle,
  tierLabel
} from '@/config/membershipTierWizardSteps'
import { railRows } from '@/helpers/membershipTierWizardRail'
import { describeSetup } from '@/helpers/membershipTierWizardSummary'
import privilegeService from '@/services/privilege.service'
import api from '@/store/api'
import { mapRelationships, mapType } from '@/store/mappers'
import MembershipTierActions from '@/view/store/membershipTierWizard/MembershipTierActions.vue'
import StepFees from '@/view/store/membershipTierWizard/steps/StepFees.vue'
import StepIncludes from '@/view/store/membershipTierWizard/steps/StepIncludes.vue'
import StepJoining from '@/view/store/membershipTierWizard/steps/StepJoining.vue'
import StepMealPlan from '@/view/store/membershipTierWizard/steps/StepMealPlan.vue'
import StepName from '@/view/store/membershipTierWizard/steps/StepName.vue'
import StepOrdering from '@/view/store/membershipTierWizard/steps/StepOrdering.vue'
import StepPackages from '@/view/store/membershipTierWizard/steps/StepPackages.vue'
import StepPass from '@/view/store/membershipTierWizard/steps/StepPass.vue'
import StepPricing from '@/view/store/membershipTierWizard/steps/StepPricing.vue'
import StepReview from '@/view/store/membershipTierWizard/steps/StepReview.vue'

const EXAMPLE_PRODUCTS = 'products?included=none&offset=5&cursor=0'
const TIERS_WITH_STORES = 'membership_tiers?included=membership_tier_store_pairs'
const STORES_WITH_PACKAGES = 'stores?included=packages'
const ENTER_OWNERS = 'textarea, button, a, [role="button"], [role="listbox"]'


export default {
  __name: 'MembershipTierWizard',
  props: { tierId: { type: String, default: null } },
  setup(__props, { expose: __expose }) {

const props = __props

const idOrNull = value => (value === null || value === undefined ? null : String(value))

const route = useRoute()
const router = useRouter()
const store = useStore()
const { showToast } = useToast()

const editing = Boolean(props.tierId)
const currency = computed(() => store.state.loggedInUser?.attributes?.currency || 'USD')
const stores = computed(() => mapType('store').map(s => ({ id: String(s.id), name: s.attributes.store_name })))
const packagesKnown = ref(false)
const tiersKnown = ref(false)
const storesKnown = computed(() => stores.value.length > 0 || packagesKnown.value)
const canSave = computed(() => privilegeService.canAccessResourceAction('sell', null, 'update'))

const packages = computed(() => {
  const storeNames = Object.fromEntries(stores.value.map(s => [s.id, s.name]))
  return mapType('package')
    .map(p => ({
      id: String(p.id),
      name: p.attributes.package_name,
      storeName: storeNames[String(p.relationships?.store?.data?.id)],
      openToAll: p.attributes.available_for_all_membership_tiers !== false,
      isOn: p.attributes.is_on !== false
    }))
    .filter(p => p.storeName)
})

const wizard = useMembershipTierWizard({
  storeId: editing ? null : route.query.store ?? null,
  tierId: props.tierId
})
provideWizard(wizard)

const stepKey = computed(() => wizard.stepKey.value)
const onReview = computed(() => stepKey.value === 'review')
const heading = computed(() => stepHeading(stepKey.value, wizard.data))
const subtitle = computed(() => stepSubtitle(stepKey.value))
const title = computed(() => wizard.data.name.trim() || (editing ? 'Membership tier' : 'New membership tier'))
const nextStep = computed(() => wizard.steps.value[wizard.step.value.index + 1])
const primaryLabel = computed(() =>
  onReview.value ? 'Create membership tier' : `Continue to ${nextStep.value?.label ?? 'Review'}`
)
const eyebrow = computed(() => {
  const label = wizard.step.value.label
  if (editing || onReview.value) return label
  return `Step ${wizard.step.value.index + 1} of ${wizard.questionCount.value} · ${label}`
})
const railOpen = ref(false)
const railButtonLabel = computed(() =>
  editing || onReview.value ? 'Settings' : `Step ${wizard.step.value.index + 1} of ${wizard.questionCount.value}`
)
const visited = ref(new Set())
watch(stepKey, key => (visited.value = new Set([...visited.value, key])), { immediate: true })

const tierEntities = computed(() => mapType('membership_tier'))
const thisTier = computed(() => tierEntities.value.find(t => String(t.id) === props.tierId))
const audienceId = computed(() => thisTier.value?.relationships?.audience?.data?.id ?? null)
const otherTiers = computed(() =>
  tierEntities.value
    .filter(t => String(t.id) !== props.tierId)
    .map(t => ({
      id: String(t.id),
      name: t.attributes.tier_name,
      downgradeId: idOrNull(t.attributes.upgrade_for_membership_tier_id)
    }))
)
const currentDefault = computed(() => {
  const tier = tierEntities.value.find(t => t.attributes.is_default && String(t.id) !== props.tierId)
  if (!tier) return null
  const pairs = mapRelationships(tier.relationships?.membership_tier_store_pairs?.data)
  return { name: tier.attributes.tier_name, storeIds: pairs.map(pair => String(pair.attributes.store_id)) }
})

const mealPlanStores = computed(() => {
  const { mode, storeIds } = wizard.data.joining
  const picked = mode === 'checkout' && storeIds.length ? storeIds : stores.value.map(s => s.id)
  return mapType('store').filter(s => picked.includes(String(s.id)))
})
const categories = computed(() => {
  const labelWithStore = mealPlanStores.value.length > 1
  return mealPlanStores.value.flatMap(s =>
    mapRelationships(s.relationships?.categories?.data)
      .filter(category => category.attributes.type !== 'UpsellCategory')
      .map(category => ({
        id: String(category.id),
        name: labelWithStore
          ? `${category.attributes.category_name} (${s.attributes.store_name})`
          : category.attributes.category_name
      }))
  )
})

const example = ref(null)

provideHighlightTerms(
  computed(() => [
    wizard.data.name.trim(),
    currentDefault.value?.name,
    ...stores.value.map(s => s.name),
    ...packages.value.map(p => p.name),
    ...otherTiers.value.map(t => t.name),
    ...categories.value.map(c => c.name),
    ...wizard.data.newPackages.map(p => p.name.trim()),
    wizard.data.pass?.name?.trim(),
    example.value?.name
  ])
)

const description = computed(() =>
  describeSetup(wizard.data, {
    stores: stores.value,
    currentDefault: currentDefault.value,
    currency: currency.value,
    currentIndex: editing ? Infinity : wizard.step.value.index,
    packages: packages.value,
    categories: categories.value,
    tiers: otherTiers.value,
    context: { editing },
    stepOk: editing ? wizard.stepOk : null
  })
)

const includeTitles = computed(() => Object.fromEntries(includeOptions(wizard.data).map(o => [o.key, o.title])))

const rail = computed(() =>
  railRows(description.value.rows, {
    currentKey: stepKey.value,
    visited: visited.value,
    includeTitles: includeTitles.value,
    editing
  })
)

const jump = key => {
  wizard.go(key)
  railOpen.value = false
}

const { state: confirmState, ask, confirm: confirmYes, cancel: confirmNo } = useConfirm()

const startOver = async () => {
  const sure = await ask({
    title: 'Start over?',
    message: 'Everything entered for this membership is cleared. Nothing has been saved yet.',
    confirmLabel: 'Start over',
    danger: true
  })
  if (!sure) return
  wizard.reset()
  visited.value = new Set(['name'])
}

const hasInput = () => Boolean(wizard.data.name.trim()) || stepKey.value !== 'name'

const cancel = async () => {
  const sure =
    !hasInput() ||
    (await ask({
      title: 'Discard this membership?',
      message: `Nothing has been saved, so everything entered for ${tierLabel(wizard.data)} is lost.`,
      confirmLabel: 'Discard',
      cancelLabel: 'Keep editing',
      danger: true
    }))
  if (!sure) return
  wizard.reset()
  router.push('/store/membership-tiers')
}

const create = async () => {
  if (!wizard.canReview.value || !canSave.value || wizard.saving.value) return
  const id = await wizard.submit()
  if (!id) return
  showToast('Membership tier created')
  router.push(`/store/membership-tiers/${id}`)
}

const save = async () => {
  if (!wizard.canSubmit.value || !canSave.value || wizard.saving.value) return
  const warnings = removalWarnings(wizard.data, wizard.meta.value)
  if (
    warnings.length &&
    !(await ask({ title: 'Save these changes?', message: warnings, confirmLabel: 'Save changes' }))
  )
    return
  const id = await wizard.submit()
  if (!id) return
  showToast('Changes saved')
  loadTiers()
  loadPackages()
}

const discard = async () => {
  const sure = await ask({
    title: 'Discard your changes?',
    message: `Every change to ${tierLabel(wizard.data)} since the last save is undone.`,
    confirmLabel: 'Discard',
    cancelLabel: 'Keep editing',
    danger: true
  })
  if (sure) wizard.reload()
}

let leaveAllowed = false

const confirmLeave = async () => {
  if (leaveAllowed || !wizard.dirty.value || wizard.saving.value) return true
  return ask({
    title: 'Leave without saving?',
    message: `Your changes to ${tierLabel(wizard.data)} have not been saved.`,
    confirmLabel: 'Leave',
    cancelLabel: 'Keep editing',
    danger: true
  })
}

const leaveAfterDelete = () => {
  leaveAllowed = true
  router.push('/store/membership-tiers')
}

if (editing) {
  useUnloadGuard(wizard.dirty)
  onBeforeRouteLeave(confirmLeave)
  onBeforeRouteUpdate((to, from) => (String(to.params.id) === String(from.params.id) ? true : confirmLeave()))
}

const advance = () => (onReview.value ? create() : wizard.next())

const onKeydown = event => {
  if (event.key !== 'Enter' || event.defaultPrevented) return
  if (event.target?.closest?.(ENTER_OWNERS)) return
  event.preventDefault()
  advance()
}

const keepKnown = (ids, known) => {
  const kept = ids.filter(id => known.includes(id))
  return kept.length === ids.length ? ids : kept
}

const syncStoreSelection = () => {
  if (editing || !stores.value.length) return
  const known = stores.value.map(s => s.id)
  const { joining, ordering, newPackages } = wizard.data
  joining.storeIds = keepKnown(joining.storeIds, known)
  if (known.length === 1 && !joining.storeIds.length) joining.storeIds = known
  if (ordering.subscriptionStoreIds) ordering.subscriptionStoreIds = keepKnown(ordering.subscriptionStoreIds, known)
  if (ordering.defaultSubscriptionStoreId && !known.includes(ordering.defaultSubscriptionStoreId))
    ordering.defaultSubscriptionStoreId = null
  newPackages.forEach(pkg => {
    if (pkg.storeId && !known.includes(pkg.storeId)) pkg.storeId = null
  })
}

const syncTierSelection = () => {
  if (editing || !tiersKnown.value) return
  const known = otherTiers.value.map(t => t.id)
  const { joining } = wizard.data
  joining.upgradeTierIds = keepKnown(joining.upgradeTierIds, known)
  if (joining.downgradeTierId && !known.includes(joining.downgradeTierId)) joining.downgradeTierId = null
}

const syncCategory = () => {
  if (editing || !categoriesKnown.value) return
  const { mealPlan } = wizard.data
  if (mealPlan.categoryId && !categories.value.some(c => c.id === mealPlan.categoryId)) mealPlan.categoryId = null
}

const syncPackageSelection = () => {
  if (editing || !packagesKnown.value) return
  const known = packages.value.map(p => p.id)
  const chosen = wizard.data.packageIds.filter(id => known.includes(id))
  if (chosen.length !== wizard.data.packageIds.length) wizard.data.packageIds = chosen
}

const loadPackages = async () => {
  try {
    await api.call('GET', STORES_WITH_PACKAGES)
    packagesKnown.value = true
    syncPackageSelection()
  } catch {
    return
  }
}

const loadTiers = async () => {
  try {
    await api.call('GET', TIERS_WITH_STORES)
    tiersKnown.value = true
    syncTierSelection()
  } catch {
    return
  }
}

const requestedCategoryStores = new Set()
const loadedCategoryStores = ref(new Set())
const categoriesKnown = computed(() => mealPlanStores.value.every(s => loadedCategoryStores.value.has(String(s.id))))

const loadCategoriesFor = async id => {
  requestedCategoryStores.add(id)
  try {
    await api.call('GET', `stores/${id}/categories?included=none`)
    loadedCategoryStores.value = new Set([...loadedCategoryStores.value, id])
    syncCategory()
  } catch {
    requestedCategoryStores.delete(id)
  }
}

const loadCategories = () => {
  if (!wizard.data.includes.mealPlan) return
  mealPlanStores.value
    .map(s => String(s.id))
    .filter(id => !requestedCategoryStores.has(id))
    .forEach(loadCategoriesFor)
}

const loadExampleProduct = async () => {
  try {
    const response = await api.call('GET', EXAMPLE_PRODUCTS)
    const product = response.data.data.find(p => p.attributes.default_price?.cents > 0)
    if (product) {
      example.value = { name: product.attributes.product_name, priceCents: product.attributes.default_price.cents }
    }
  } catch {
    example.value = null
  }
}

onMounted(() => {
  if (!editing) window.addEventListener('keydown', onKeydown)
  loadPackages()
  loadTiers()
  syncStoreSelection()
  loadExampleProduct()
})
watch(() => stores.value.map(s => s.id).join(','), syncStoreSelection)
watch(() => packages.value.map(p => p.id).join(','), syncPackageSelection)
watch(() => [wizard.data.includes.mealPlan, mealPlanStores.value.map(s => s.id).join(',')], loadCategories, {
  immediate: true
})
if (!editing) tierDraft.follow(() => wizard.data.name.trim())
onBeforeUnmount(() => window.removeEventListener('keydown', onKeydown))

__expose({ wizard })

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(SecondaryNav, { "full-width": "" }, {
    top: _withCtx(() => [
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("nav", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: "/store/membership-tiers",
              class: "hover:text-gray-900"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("Membership Tiers", -1)
              ]))]),
              _: 1
            }),
            _cache[3] || (_cache[3] = _createElementVNode("span", {
              "aria-hidden": "true",
              class: "mx-1"
            }, "/", -1)),
            (_unref(editing))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  "data-overview-link": "",
                  to: `/store/membership-tiers/${__props.tierId}`,
                  class: "hover:text-gray-900"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(title.value), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, "New tier"))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", _hoisted_6, _toDisplayString(title.value), 1),
            (!_unref(editing) || _unref(wizard).dirty.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(editing) ? 'Unsaved changes' : 'Draft · not saved'), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(WizardButton, {
            class: "min-[1100px]:hidden",
            "aria-expanded": railOpen.value,
            onClick: _cache[0] || (_cache[0] = $event => (railOpen.value = !railOpen.value))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(railButtonLabel.value), 1)
            ]),
            _: 1
          }, 8, ["aria-expanded"]),
          (!_unref(editing))
            ? (_openBlock(), _createBlock(WizardButton, {
                key: 0,
                onClick: cancel
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (_unref(wizard).loadError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(wizard).loadError.value), 1),
                    _createVNode(WizardButton, {
                      "data-retry": "",
                      onClick: _unref(wizard).reload
                    }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("Try again", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : (_unref(wizard).loading.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, "Loading the membership"))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("p", _hoisted_17, _toDisplayString(eyebrow.value), 1),
                        _createElementVNode("h2", _hoisted_18, _toDisplayString(heading.value), 1),
                        (subtitle.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(subtitle.value), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (_unref(editing) && _unref(wizard).errors.value.length)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_20, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wizard).errors.value, (error) => {
                              return (_openBlock(), _createElementBlock("li", { key: error }, _toDisplayString(error), 1))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_21, [
                        (stepKey.value === 'name')
                          ? (_openBlock(), _createBlock(StepName, { key: 0 }))
                          : (stepKey.value === 'joining')
                            ? (_openBlock(), _createBlock(StepJoining, {
                                key: 1,
                                stores: stores.value,
                                "stores-known": storesKnown.value,
                                "current-default": currentDefault.value,
                                tiers: otherTiers.value,
                                "editing-id": __props.tierId
                              }, null, 8, ["stores", "stores-known", "current-default", "tiers", "editing-id"]))
                            : (stepKey.value === 'includes')
                              ? (_openBlock(), _createBlock(StepIncludes, { key: 2 }))
                              : (stepKey.value === 'ordering')
                                ? (_openBlock(), _createBlock(StepOrdering, {
                                    key: 3,
                                    stores: stores.value
                                  }, null, 8, ["stores"]))
                                : (stepKey.value === 'mealPlan')
                                  ? (_openBlock(), _createBlock(StepMealPlan, {
                                      key: 4,
                                      categories: categories.value,
                                      "categories-known": categoriesKnown.value
                                    }, null, 8, ["categories", "categories-known"]))
                                  : (stepKey.value === 'pricing')
                                    ? (_openBlock(), _createBlock(StepPricing, {
                                        key: 5,
                                        example: example.value,
                                        currency: currency.value
                                      }, null, 8, ["example", "currency"]))
                                    : (stepKey.value === 'packages')
                                      ? (_openBlock(), _createBlock(StepPackages, {
                                          key: 6,
                                          packages: packages.value,
                                          stores: stores.value
                                        }, null, 8, ["packages", "stores"]))
                                      : (stepKey.value === 'pass')
                                        ? (_openBlock(), _createBlock(StepPass, {
                                            key: 7,
                                            currency: currency.value
                                          }, null, 8, ["currency"]))
                                        : (stepKey.value === 'fees')
                                          ? (_openBlock(), _createBlock(StepFees, {
                                              key: 8,
                                              currency: currency.value
                                            }, null, 8, ["currency"]))
                                          : (_openBlock(), _createBlock(StepReview, {
                                              key: 9,
                                              description: description.value,
                                              errors: _unref(wizard).errors.value
                                            }, null, 8, ["description", "errors"]))
                      ])
                    ], 64))
            ])
          ]),
          (!_unref(wizard).loadError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                (_unref(editing))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      (_unref(wizard).dirty.value)
                        ? (_openBlock(), _createBlock(WizardButton, {
                            key: 0,
                            "data-discard": "",
                            disabled: _unref(wizard).saving.value,
                            onClick: discard
                          }, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                              _createTextVNode(" Discard changes ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (!canSave.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_24, " Your role can't save changes to membership tiers. "))
                        : (_unref(wizard).blockingStep.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_25, " Finish " + _toDisplayString(_unref(wizard).blockingStep.value.label) + " before saving. ", 1))
                          : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(WizardNav, {
                          "primary-label": "Save changes",
                          "primary-enabled": _unref(wizard).canSubmit.value && canSave.value,
                          loading: _unref(wizard).saving.value,
                          arrow: false,
                          onPrimary: save
                        }, null, 8, ["primary-enabled", "loading"])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      (onReview.value && !canSave.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_28, " Your role can't create membership tiers. "))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(WizardNav, {
                          "show-back": _unref(wizard).step.value.index > 0,
                          "primary-label": primaryLabel.value,
                          "primary-enabled": onReview.value ? _unref(wizard).canReview.value && canSave.value : _unref(wizard).valid.value,
                          loading: _unref(wizard).saving.value,
                          arrow: !onReview.value,
                          onBack: _unref(wizard).back,
                          onPrimary: advance
                        }, null, 8, ["show-back", "primary-label", "primary-enabled", "loading", "arrow", "onBack"])
                      ])
                    ]))
              ]))
            : _createCommentVNode("", true)
        ]),
        (railOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-30 bg-black/20 min-[1100px]:hidden",
              onClick: _cache[1] || (_cache[1] = $event => (railOpen.value = false))
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          "data-so-far": "",
          class: _normalizeClass(["w-80 flex-shrink-0 border-l border-gray-200 bg-white min-[1100px]:static min-[1100px]:block min-[1100px]:shadow-none", railOpen.value ? 'fixed inset-y-0 right-0 z-40 overflow-y-auto shadow-xl' : 'hidden'])
        }, [
          _createVNode(WizardRail, {
            rows: rail.value,
            title: _unref(editing) ? 'Settings' : 'Setup',
            "show-progress": !_unref(editing),
            onJump: jump
          }, {
            default: _withCtx(() => [
              (_unref(editing))
                ? (_openBlock(), _createBlock(MembershipTierActions, {
                    key: 0,
                    "tier-id": __props.tierId,
                    "tier-name": _unref(wizard).data.name,
                    "tier-type": _unref(wizard).meta.value.tier_type,
                    "audience-id": audienceId.value,
                    onDeleted: leaveAfterDelete
                  }, null, 8, ["tier-id", "tier-name", "tier-type", "audience-id"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[7] || (_cache[7] = _createElementVNode("p", { class: "m-0 text-[13px] text-gray-500" }, "Nothing is saved until you press Create membership tier.", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "mt-2 text-[13px] text-gray-600 underline hover:text-gray-900",
                      onClick: startOver
                    }, " Start over ")
                  ], 64))
            ]),
            _: 1
          }, 8, ["rows", "title", "show-progress"])
        ], 2)
      ]),
      _createVNode(WizardConfirmModal, _mergeProps(_unref(confirmState), {
        onConfirm: _unref(confirmYes),
        onCancel: _unref(confirmNo)
      }), null, 16, ["onConfirm", "onCancel"])
    ]),
    _: 1
  }))
}
}

}